<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { RowInfo, RowSlot } from '@shared/ui/other'
import { CardAdmin } from '@shared/ui/cards'
import { BtnPrimary } from '@shared/ui/buttons'

import CustomerReferralsTable from '../CustomerReferralsTable.vue'
import CustomerCreditsHistoryTable from '../CustomerCreditsHistoryTable.vue'
import { useCustomerCredits } from '../../model/credits/customer-credits.hook'

defineOptions({
  name: 'SectionCustomerCredits',
})

const {
  refBalance,
  refReferralLink,
  canManage,
  refReferrals,
  refReferralsMeta,
  isReferralsLoading,
  refTransactions,
  isTransactionsLoading,
  emptyCell,
  formatDate,
  formatPrice,
  formatAmount,
  getCustomerPath,
  openEdit,
  setReferralsPage,
  setReferralsPerPage,
} = useCustomerCredits()
</script>

<template>
  <div class="section-customer-credits">
    <CardAdmin
      title="Credits"
      fullwidth
    >
      <template #header>
        <BtnPrimary
          v-if="canManage"
          text="Edit balance"
          color="emerald"
          @click="openEdit"
        />
      </template>
      <div class="section-customer-credits__info">
        <RowSlot label="Credits balance">
          <AppText
            name="body1-medium"
            color="slate-900"
          >
            {{ refBalance }}
          </AppText>
        </RowSlot>
        <RowSlot label="Referral link">
          <RowInfo
            :value="refReferralLink"
            is-copy-show
          />
        </RowSlot>
      </div>
    </CardAdmin>

    <CardAdmin
      title="Referrals"
      fullwidth
      class="section-customer-credits__table-card"
    >
      <CustomerReferralsTable
        :referrals="refReferrals"
        :meta="refReferralsMeta"
        :loading="isReferralsLoading"
        :empty-cell="emptyCell"
        :format-date="formatDate"
        :get-customer-path="getCustomerPath"
        @change:page="setReferralsPage"
        @change:per-page="setReferralsPerPage"
      />
    </CardAdmin>

    <CardAdmin
      title="Credits history"
      fullwidth
      class="section-customer-credits__table-card"
    >
      <CustomerCreditsHistoryTable
        :transactions="refTransactions"
        :loading="isTransactionsLoading"
        :empty-cell="emptyCell"
        :format-date="formatDate"
        :format-price="formatPrice"
        :format-amount="formatAmount"
      />
    </CardAdmin>
  </div>
</template>

<style scoped lang="scss" src="./SectionCustomerCredits.scss" />
